// @flow

import React, { useContext } from 'react';
import styles from './tableActionButton.scss';
import UserContext from '../../../services/context/usercontext';

type TableActionButtonProps = {
  button: Object,
  rowData: Object,
  modalTheme?: Object
};

type RenderTableActionButtonProps = {
  buttonConfig: Array<Object>,
  rowData: Object,
  modalTheme?: Object
};

export const DepositTableActionButton = (props: TableActionButtonProps) => (
  <div
    className={`${
      props.modalTheme && props.modalTheme.name
        ? styles[props.modalTheme.name]
        : ''
    } ${styles.depositActionButtonWrapper}`}
    onClick={() => props.button.onClick(props.rowData)}
  >
    <div
      className={styles.iconContainer}
      style={
        props.rowData.isSelected && props.rowData.isSelected === true
          ? { opacity: '1' }
          : {
              opacity: '0.5'
            }
      }
    >
      <img className={styles.image} src={props.button.iconRef} alt="img" />
    </div>
  </div>
);

export const TableActionButton = (props: TableActionButtonProps) => {
  if (props.button && props.button.iconOnly) {
    return (
      <div
        className={styles.iconContainer}
        style={props.button.iconStyle ? props.button.iconStyle : {}}
        title={props.button.label}
        onClick={() => props.button.onClick(props.rowData)}
      >
        {!props.button.iconCb ? (
          <img className={styles.image} src={props.button.iconRef} alt="img" />
        ) : null}
        {props.button.iconCb && typeof props.button.iconCb === 'function'
          ? props.button.iconCb(props.rowData)
          : null}
      </div>
    );
  }
  if (props.button && props.button.labelOnly) {
    return (
      <div
        className={
          (typeof props.button.label === 'function' &&
            !props.button.label(props.rowData)) ||
          props.button.label === ''
            ? 'is-hidden'
            : ''
        }
      >
        <button
          onClick={() => props.button.onClick(props.rowData)}
          className={styles.labelWrapper}
        >
          {typeof props.button.label === 'function'
            ? props.button.label(props.rowData)
            : props.button.label}
        </button>
      </div>
    );
  }
  return (
    <div
      className={`${
        props.modalTheme && props.modalTheme.name
          ? styles[props.modalTheme.name]
          : ''
      } ${styles.actionButtonWrapper}`}
      onClick={() => props.button.onClick(props.rowData)}
    >
      <div className={styles.iconContainer}>
        <img className={styles.image} src={props.button.iconRef} alt="img" />
      </div>
      <div className={styles.label}>
        {typeof props.button.label === 'function'
          ? props.button.label(props.rowData)
          : props.button.label}
      </div>
    </div>
  );
};

export const TableActionButtonRetail = (props: TableActionButtonProps) => (
  <div
    className={`${
      props.modalTheme && props.modalTheme.name
        ? styles[props.modalTheme.name]
        : ''
    } ${styles.actionButtonRetailWrapper}
      ${props.disabled ? styles.disabledButton : ''}`}
    onClick={() => props.button.onClick(props.rowData)}
    style={props.button.actionButtonRetailWrapper}
  >
    <div className={`${styles.actionButtonRetail} action-button-retail`}>
      {typeof props.button.label === 'function'
        ? props.button.label(props.rowData)
        : props.button.label}
    </div>
  </div>
);

export const RenderTableActionButtons = (
  props: RenderTableActionButtonProps
) => (
  <div
    className={`${
      props.modalTheme && props.modalTheme.name
        ? styles[props.modalTheme.name]
        : ''
    } ${styles.actionButtonsGroup}`}
  >
    {props.buttonConfig.map((button, index) => (
      <div key={index} style={button.style}>
        {button.hide && button.hide(props.rowData) ? (
          ''
        ) : (
          <TableActionButton
            button={button}
            rowData={props.rowData}
            modalTheme={props.modalTheme}
          />
        )}
      </div>
    ))}
  </div>
);

export const RenderRetailTableActionButtons = (
  props: RenderTableActionButtonProps
) => {
  const userProfile = useContext(UserContext);
  return (
    <div
      className={`${
        props.modalTheme && props.modalTheme.name
          ? styles[props.modalTheme.name]
          : ''
      }`}
    >
      {props.buttonConfig.map((button, index) => (
        <div key={index}>
          {button.hide && button.hide(props.rowData, userProfile) ? (
            ''
          ) : (
            <TableActionButtonRetail
              button={button}
              rowData={props.rowData}
              modalTheme={props.modalTheme}
              disabled={
                button.disabledFn ? button.disabledFn(props.rowData) : false
              }
            />
          )}
        </div>
      ))}
    </div>
  );
};

export const RenderDepositSlipTableActionButtons = (
  props: RenderTableActionButtonProps
) => (
  <div
    className={`${
      props.modalTheme && props.modalTheme.name
        ? styles[props.modalTheme.name]
        : ''
    } ${styles.actionButtonsGroup}`}
  >
    {props.buttonConfig.map((button, index) => (
      <div key={index} style={button.style}>
        {button.hide && button.hide(props.rowData) ? (
          ''
        ) : (
          <DepositTableActionButton
            button={button}
            rowData={props.rowData}
            modalTheme={props.modalTheme}
          />
        )}
      </div>
    ))}
  </div>
);

TableActionButton.defaultProps = {
  modalTheme: { name: null }
};

TableActionButtonRetail.defaultProps = {
  modalTheme: { name: null }
};

RenderTableActionButtons.defaultProps = {
  modalTheme: { name: null }
};

RenderRetailTableActionButtons.defaultProps = {
  modalTheme: { name: null }
};

DepositTableActionButton.defaultProps = {
  modalTheme: { name: null }
};

RenderDepositSlipTableActionButtons.defaultProps = {
  modalTheme: { name: null }
};
